import { Button, Flex, Spin, Transfer, TransferProps, Typography } from "antd";
import styled from "styled-components";
import { useDeleteDeprecatedVSkuMutation, useGetDeprecatedVSkusQuery, useGetInventoryOverviewQuery, useGetInventoryOverviewWithDeprecatedQuery, usePostDeprecatedVSkuMutation } from "../../../api/inventory/inventoryApi";
import { useState } from "react";
import { WarningOutlined } from "@ant-design/icons";
import { TransferDirection, TransferItem } from "antd/es/transfer";

const StyledTransfer = styled(Transfer)`
  flex: 1;
  width: 100%;
  height: 100%;
  .ant-transfer-list {
    width: 100%;
    height: 100%;
    min-height: 400px;
  }
`;

type TransferVSku = {
  key: string;
  title: string;
  description?: string;
  disabled?: boolean;
}

export default function DeprecatePage() {
  const { data, error, isFetching } = useGetInventoryOverviewWithDeprecatedQuery();
  const { data: deprecatedData, error: errDep, isFetching: depIsFetching, refetch }
      = useGetDeprecatedVSkusQuery();

  const [postDeprecate] = usePostDeprecatedVSkuMutation();
  const [deleteDeprecate] = useDeleteDeprecatedVSkuMutation();

  const availVskus = data?.map(d => ({
    key: d.title,
    title: d.title,
  })) ?? [];
  const depVskus = deprecatedData?.map(d => d.VendorSku) ?? [];

  // const depVSkusTI = depVskus.map(d => ({
  //   key: d,
  //   title: d,
  // }));

  const [toDeprecate, setToDeprecate] = useState<string[]>([]);
  const [toRestore, setToRestore] = useState<string[]>([]);

  // const [targetKeys, setTargetKeys] =
  //     useState<TransferProps["targetKeys"]>(depVskus);
  // const [selectedKeys, setSelectedKeys] =
  //     useState<TransferProps["selectedKeys"]>([]);

  function handleTransfer(targetKeys: string[],
                          direction: TransferDirection,
                          moveKeys: string[]) {
    console.log("transferring", targetKeys, direction, moveKeys);
    if (direction === "right") {
      let items = [...new Set([...toDeprecate, ...moveKeys])];

      // remove those already in depVSkus
      items = items.filter(x => !depVskus.includes(x));
      setToDeprecate(items);

      // remove from restore if exists
      const newRestore = toRestore.filter(x => !moveKeys.includes(x));
      setToRestore(newRestore);
    //   const origIds = props.p.ProductIds ?? [];
    //   // dedupe
    //   const items = [...new Set([...origIds, ...targetKeys])];
    //   props.setP({ ...props.p, ProductIds: items})
    } else {
      let items = [...new Set([...toRestore, ...moveKeys])];

      // remove those which are not in depVskus
      items = items.filter(x => depVskus.includes(x));
      setToRestore(items);

      // remove from deprecate if exists
      const newDep = toDeprecate.filter(x => !moveKeys.includes(x));
      setToDeprecate(newDep);

    //   const newIds = props.p.ProductIds?.filter(x => !moveKeys.includes(x));
    //   props.setP({ ...props.p, ProductIds: newIds });
    }
  }

  function handleSave() {
    console.log("saving changes", toDeprecate, toRestore);
    toDeprecate.forEach(vsku => {
      postDeprecate(vsku);
    });
    toRestore.forEach(vsku => {
      deleteDeprecate(vsku);
    });

    // wait a bit and refetch
    setTimeout(() => {

      refetch();
      setToDeprecate([]);
      setToRestore([]);
    }, 1000);
  }

  const invTitle = isFetching ? <Spin /> : error ? <WarningOutlined /> : "Inventory";
  const depTitle = depIsFetching ? <Spin /> : errDep ? <WarningOutlined /> : "Deprecated";

  console.log("vsku dep page" , availVskus, depVskus);

  return (
    <Flex gap={8} vertical style={{ width: "100%" }}>
      <Typography.Title level={2}>Deprecate Provider Codes</Typography.Title>
      <Typography.Text>
        Discontinued (deprecated) provider codes will no longer show up on the
        inventory quantity overview.

      </Typography.Text>
      {/* <Typography.Text>
        Do note this will only apply to eSIMs that are out of stock already.
        Existing eSIMs with the deprecated provider codes will still be
        displayed on the homepage.
      </Typography.Text> */}
      <Flex justify="end">
        <Button onClick={handleSave}>Save Changes</Button>
      </Flex>
      <StyledTransfer
        dataSource={availVskus}
        targetKeys={[...depVskus.filter(x => !toRestore.includes(x)), ...toDeprecate]}
        titles={[invTitle, depTitle]}
        onChange={handleTransfer}
        render={(item: TransferItem) => item.title ?? ""}
      />
    </Flex>
  );
}